import {FC} from 'react'
import {Card} from 'react-bootstrap'
import bgImage from '../../assets/img/bg.png'
import lpdpLogo from '../../../../src/assets/img/logo-lpdp.png'
import {toTitleCaseUnicode, truncateText} from 'thesis-and-dissertations/helpers/helper'

type Props = {
  data: any
  isMobile?: boolean
}

const Page1: FC<Props> = ({data, isMobile = false}) => {
  const styles = {
    logo: {
      width: isMobile ? '70px' : '90px',
    },
    profileImage: {
      width: isMobile ? '100px' : '130px',
      height: isMobile ? '135px' : '175px',
      borderRadius: '25px',
    },
    badge: {
      textTransform: 'uppercase' as 'uppercase',
      display: 'inline-block',
      borderRadius: '100px',
      padding: isMobile ? '5px 8px' : '7px 10px',
      color: '#F26B01',
      backgroundColor: '#FFF',
      fontWeight: 600,
      fontSize: isMobile ? '10px' : '11px',
      marginRight: '5px',
      marginTop: '5px',
    },
  }

  return (
    <Card className='h-100 border-0 bg-light bg-opacity-75 shadow-sm' style={{borderRadius: '0'}}>
      <div
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          height: '100%',
        }}
        className={isMobile ? 'p-8' : 'p-14'}
      >
        <div className='row'>
          <div className='col-md-8 col-12'>
            <div>
              <img src={lpdpLogo} style={styles.logo} alt='logo' />
            </div>

            <div className='mt-4'>
              {data?.jenjang_studi && <span style={styles.badge}>{data?.jenjang_studi}</span>}
              {data?.batch_pk && <span style={styles.badge}>{data?.batch_pk}</span>}
              {data?.tahun_lulus && <span style={styles.badge}>{data?.tahun_lulus}</span>}
              {data?.program_beasiswa && <span style={styles.badge}>{data?.program_beasiswa}</span>}
            </div>
          </div>
          <div className='col-md-4 col-12 mt-3 mt-md-0 d-flex justify-content-md-end justify-content-center'>
            <img src={data?.foto_profil_url} style={styles.profileImage} alt={data?.nama_lengkap} />
          </div>

          <div className='col-md-12'>
            <div className='mt-3'>
              <p>Hello! My Names</p>

              <p
                className={isMobile ? 'h3' : 'display-6'}
                style={{fontWeight: 450, textTransform: 'capitalize'}}
              >
                {data?.nama_lengkap && toTitleCaseUnicode(data?.nama_lengkap)}
              </p>

              <p>
                {data?.pekerjaan_saat_ini}{' '}
                {data?.perusahaan_instansi && `(${data?.perusahaan_instansi})`}
              </p>
            </div>

            {data?.biography && (
              <div
                className='mt-2'
                style={{
                  background:
                    'linear-gradient(to right, rgba(253,249,234,0.7) 0%, rgba(253,249,234,1) 100%)',
                  borderRadius: '12px',
                  padding: isMobile ? '12px' : '18px',
                }}
              >
                <p>Biography</p>
                <div className='px-2'>
                  <p style={{fontSize: isMobile ? '14px' : 'inherit'}}>
                    {truncateText(data?.biography, isMobile ? 180 : 260)}
                  </p>
                </div>
              </div>
            )}

            <div
              className='mt-2 p-4 shadow border-0'
              style={{
                background: 'linear-gradient(90deg, #F9FAFB 0%, #EFF6FF 100%)',
                borderRadius: '12px',
              }}
            >
              {data?.kutipan_inspiratif && (
                <>
                  <i className='fa fa-quote-left' style={{color: '#BEDBFF'}}></i>

                  <div
                    style={{
                      fontStyle: 'italic',
                      letterSpacing: '0%',
                      verticalAlign: 'middle',
                    }}
                  >
                    <p style={{fontSize: isMobile ? '14px' : 'inherit'}}>
                      {truncateText(data?.kutipan_inspiratif, isMobile ? 180 : 260)}
                    </p>
                  </div>
                </>
              )}

              {/* Footer: Profile + Button */}
              <div className='d-flex justify-content-between align-items-center mt-4'>
                <div className='d-flex align-items-center'>
                  <img
                    src={data?.foto_profil_url}
                    alt={data?.nama_lengkap}
                    width={isMobile ? 40 : 50}
                    height={isMobile ? 40 : 50}
                    className='me-3'
                    style={{
                      border: '2px solid #BEDBFF',
                      borderColor: '#BEDBFF',
                      borderRadius: '50%',
                    }}
                  />
                  <div>
                    <h6 className='fw-bold mb-0' style={{fontSize: isMobile ? '14px' : 'inherit'}}>
                      {data?.nama_lengkap && toTitleCaseUnicode(data?.nama_lengkap)}
                    </h6>
                    <small className='text-muted'>LPDP Alumni {data?.tahun_lulus}</small>
                  </div>
                </div>

                <div
                  className='py-1 bg-white text-black rounded d-flex align-items-center justify-content-between'
                  style={{
                    border: '1px solid #BEDBFF',
                    width: isMobile ? '85px' : '100px',
                    fontSize: isMobile ? '12px' : 'inherit',
                  }}
                >
                  <img
                    src={require('../../assets/img/linkedin.png')}
                    style={{
                      width: isMobile ? '12px' : '14px',
                      height: isMobile ? '12px' : '14px',
                      marginLeft: isMobile ? '6px' : '8px',
                    }}
                    alt='linkedin'
                  />
                  <a
                    href={data?.linkedin_profile ?? '#'}
                    target='_blank'
                    style={{marginRight: isMobile ? '6px' : '8px'}}
                    className='text-black'
                  >
                    Connect
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
  )
}

export default Page1
